module.exports = __webpack_public_path__ + "static/media/shelter_anchorage_marker.662bf1e3.svg";